import ApplicationAdapter from './application';

export default class Date extends ApplicationAdapter {
  namespace = 'dates/v4';
  modelNamePlural = 'dates';
}
